import { FC, useState, useEffect } from 'react';
import { CommonModal } from '../CommonModal';
import { ConfirmTitleWithBorder } from '../ModalItem/ConfirmTitleWithBorder';
import confirmModalClass from '../../assets/scss/ConfirmModal/ConfirmModal.module.scss';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { BottomButton } from '../ModalItem/BottomButton';
import { SubscriptionApiType } from '../../types/api/SubscriptionApiType';
import { postMessageGtag } from '../../utils/trackClick';

export const NewOrderModal: FC<{
  active: boolean;
  closeFunc: () => void;
  loading: boolean;
  clickOrderBtnFunc: () => void;
  isAfterProductUpdate?: boolean;
  handleOrderClose: () => void;
  subscription?: SubscriptionApiType;
}> = ({
  active,
  closeFunc,
  loading,
  clickOrderBtnFunc,
  isAfterProductUpdate,
  handleOrderClose,
  subscription,
}) => {
  //デフォルトメッセージ
  const [nextDeliveryMessage, setNextDeliveryMessage] = useState<string>('');

  useEffect(() => {
    if (subscription) {
      // 周期に基づいて次回お届け日のメッセージを生成
      const interval = subscription.billingPolicyInterval;
      const intervalCount = subscription.billingPolicyIntervalCount;

      let message = '次回のお届け日は';

      if (interval === 'DAY') {
        message += `${intervalCount}日後になります`;
      } else if (interval === 'WEEK') {
        message += `${intervalCount}週間後になります`;
      } else if (interval === 'MONTH') {
        message += `${intervalCount}ヶ月後になります`;
      } else {
        message += `${intervalCount}年後になります`;
      }

      setNextDeliveryMessage(message);
    }
  }, [subscription]);

  const onClickClose = () => {
    closeFunc();
    postMessageGtag('click_modal_close_OrderNow_cancel', 'detailCalender');
  };

  const onClickOutsideClose = () => {
    closeFunc();
    postMessageGtag('click_modal_close_OrderNow', 'detailCalender');
  };

  const content = (
    <>
      <ConfirmTitleWithBorder title="お届け予定の商品を最短でお届け" />
      <div className={confirmModalClass.detailContainer}>
        <div style={{ marginBottom: '24px' }}>
          <ul>
            <li>
              <span>
                <span className={confirmModalClass.detailHighlight}>注文を確定</span>
                し、すぐに発送の準備を開始（2～3日以内に発送します）
              </span>
            </li>
            <li>
              <span>{nextDeliveryMessage}</span>
            </li>
          </ul>
        </div>
        <div>商品がなくなってしまった時や新商品など早く届けてほしい商品がある時に便利。</div>
      </div>
      <div
        className={confirmModalClass.border}
        style={{ marginBottom: '40px', marginTop: '0px' }}
      ></div>
      <div className={commonModalClass.btnContainer}>
        <button
          className={commonModalClass.btnSecondary}
          onClick={() => {
            clickOrderBtnFunc();
            handleOrderClose();
            postMessageGtag('click_OrderNow', 'detailCalender');
          }}
          disabled={loading}
        >
          注文を確定して最短で届ける
        </button>
        <BottomButton
          buttonTitle="キャンセル"
          clickFunc={onClickClose}
        />
      </div>
    </>
  );

  return (
    <CommonModal
      active={active}
      closeFunc={onClickOutsideClose}
      loading={loading}
    >
      {content}
    </CommonModal>
  );
};
